export default __webpack_public_path__ + "static/media/notVerified.97c4aafa.svg";